import TealiumEventBuilder from '../../analytics/tealium/builders/tealium-event-builder';

class FulfilmentSelectorDialogController {
    constructor($scope, $state, settings, fulfilmentSelectorService, analyticsService, heartbeatService, $timeout, dialogRegistry) {

        this.$scope = $scope;
        this.$state = $state;
        this.settings = settings;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
        this.heartbeatService = heartbeatService;
        this.$timeout = $timeout;
        this.dialogRegistry = dialogRegistry;

        this.onInit();
    }

    onInit() {
        this.isError = false;
        this.$scope.$on('error', () => {
            this.isError = true;
        });
        this.$scope.$on('offline', () => {
            this.isError = true;
        });

        // Check server session every 30 seconds.
        this.heartbeatService.startWaitingForContextExpiry(30000);
    }

    goToConfirmStep() {
        const event = new TealiumEventBuilder()
            .withScreenName('Manual Address entry')
            .withLabel('Button/link click')
            .withValue('Back')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();

        this.analyticsService.push(event);
        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.confirm;
    }

    onRedirectClick() {
        const dialog = this.dialogRegistry.getDialog('fulfilment-selector-dialog');
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Button/link click')
            .withValue('Close')
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);

        if (dialog) {
            dialog.close();
        }
        this.$timeout(() => {
            this.$state.go('root');
        }, 500);
    }

    $onDestroy() {
        // Reset to regular check time.
        this.heartbeatService.startContextHeartbeat();
        this.fulfilmentSelectorService.unsubscribeEsc(this.screenName);
    }
}

FulfilmentSelectorDialogController.$inject = ['$scope', '$state', 'Settings', 'FulfilmentSelectorService', 'AnalyticsService', 'HeartbeatService', '$timeout', 'DialogRegistry'];

const fulfilmentSelectorDialogComponentDefinition = {
    controller: FulfilmentSelectorDialogController,
    template: require('./fulfilment-selector-dialog.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDialogController,
    fulfilmentSelectorDialogComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-dialog.component.js